<template>
    <div class="cta-image-area_one section-space--ptb_120">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="cta-image cta-image-bg bg-cover">
                        <div class="row align-items-center">
                            <div class="col-lg-6 order-2 order-lg-1">
                                <div class="cta-image__content">
                                    <h4 class="cta-image__title text-white mb-20 wow move-up">Scrivici per maggiori informazioni</h4>
                                    <div class="cta-image__text text-white mb-20 wow move-up">o richiedere una demo</div>
                                    <a href="mailto:info@64-bit.it" class="btn btn--green">Scrivici a info@64-bit.it</a>
                                </div>
                            </div>
                            <div class="col-lg-6 order-1 order-lg-2">
                                <div class="cta-image__media wow move-up">
                                    <img src="../assets/img/banners/simple_service_3.png" class="img-fluid" alt="Simple Service">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CtaOne',
    }
</script>
